import React, { ReactNode } from 'react';

import { TProgressGaugeColor } from '../../interfaces/types';

interface IProgressGaugeProps {
    percentage: number;
    children: ReactNode;
    color: TProgressGaugeColor;
};

export const ProgressGauge = (props: IProgressGaugeProps) => {
    const { percentage, children, color } = props;

    return (
        <div className='immployer__progress_gauge'>
            <div className='immployer__progress_gauge__body'>
                <div
                    className={`immployer__progress_gauge__fill immployer__progress_gauge__fill__color_${color}`}
                    style={{ transform: `rotate(${(percentage / 100) / 2}turn)` }}
                />
                <div className='immployer__progress_gauge__cover'>
                    {children}
                </div>
            </div>
        </div>
    );
};